import useLoggedInUser from '@/composables/logged-in-user/logged-in-user';
import { formatChartNumber } from '@/lib/charts/format';

export default function useChartValueFormatter(chart) {
  const { userLang } = useLoggedInUser();
  const formatValue = (value) => formatChartNumber(value, {
    precision: chart?.value?.precision,
    locale: userLang.value,
  });
  return { formatValue };
}
